import React, { useMemo, useState } from "react";

const IframeEmbed = ({ url }) => {
  const [iframeKey, setIframeKey] = useState(0);

  const cleaned = useMemo(() => {
    if (!url) return "";
    let newUrl = url.trim().replace(/['"]+/g, "");
    return newUrl;
  }, [url]);
  // console.log(cleaned, "url");

  return (
    <iframe
      key={iframeKey}
      src={cleaned}
      title="embedded"
      style={{
        width: "100%",
        height: "100%",
        border: "none",
        minHeight: "400px",
      }}
      sandbox="allow-same-origin allow-scripts allow-forms allow-popups"
    />
  );
};

export default IframeEmbed;
